import React from 'react';
import styled from 'styled-components';
import { type AcademicRefereeFormProps } from './types';
import { APPLICATION_TEXT } from '../../lang';
import { DocumentBox } from '../../../../../components';

const ACADEMIC_REFEREE = APPLICATION_TEXT.ACADEMIC_REFEREE;
export const AcademicRefereeForm: React.FunctionComponent<
  AcademicRefereeFormProps
> = (props: AcademicRefereeFormProps) => {
  const { academicReferee, academicRefereeIndex } = props;
  const {
    title,
    name,
    institution,
    position,
    relationship,
    email,
    referenceReport,
  } = academicReferee;

  const hasReferenceReport: boolean = Boolean(referenceReport?.id);

  const renderData = [
    {
      label: ACADEMIC_REFEREE.REFEREE_TITLE,
      value: title,
      isFullWidth: false,
    },
    {
      label: ACADEMIC_REFEREE.REFEREE_NAME,
      value: `${name.surname?.toUpperCase()} ${name.givenName}`,
      isFullWidth: false,
    },
    {
      label: ACADEMIC_REFEREE.INSTITUTION,
      value: institution,
      isFullWidth: true,
    },
    {
      label: ACADEMIC_REFEREE.POSITION,
      value: position,
      isFullWidth: false,
    },
    {
      label: ACADEMIC_REFEREE.RELATIONSHIP,
      value: relationship,
      isFullWidth: false,
    },
    {
      label: ACADEMIC_REFEREE.EMAIL,
      value: email,
      isFullWidth: true,
    },
  ];

  return (
    <Container>
      <h1>
        {ACADEMIC_REFEREE.SUBTITLE}
        {' - '}
        {academicRefereeIndex + 1}
      </h1>
      <div className="grid grid-cols-2 px-8 py-2 text-sm w-full">
        {renderData.map((item, index) => {
          return (
            <div key={index} className="py-2 border-b border-solid">
              <span className="text-[#224295]">{item.label}</span>:&nbsp;&nbsp;
              {item.value}
            </div>
          );
        })}
      </div>
      <div className="supporting-documents">
        <h3>{`Referee's Reports`}</h3>
        <div className="document-display">
          {hasReferenceReport ? (
            <DocumentBox file={referenceReport} />
          ) : (
            <div className="text-sm">{APPLICATION_TEXT.NA}</div>
          )}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h1 {
    text-align: left !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    margin: 1rem !important;
  }

  display: flex;
  flex-direction: column;
  width: 100%;

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }

  .supporting-documents {
    padding: 0.5rem 0 0 2rem;

    .document-display {
      padding: 0.5rem 1rem;
    }

    h3 {
      font-style: italic;
      color: #8c8c8c;
    }
  }
`;
